import { LinkedCaseEntity } from './linked-case.entity';

/**
 * Parent/child cases domain entity.
 * Represents the parent/child hierarchy for a case.
 */
export class ParentChildCasesEntity {
  public parent: LinkedCaseEntity | null = null;
  public children: LinkedCaseEntity[] = [];
}
